
export type ITSIterator<T, TReturn = void, TNext = undefined> = Iterator<T, TReturn, TNext>;

export type ITSIteratorResult<T, TReturn = void> = IteratorResult<T, TReturn>;
